module.exports = { "default": require("core-js/library/fn/number/is-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/core-js/number/is-integer.js
// module id = 444
// module chunks = 13 23